<template>
  <div class="home">
    <Head :loginStatus="loginStatus" :hotLink="hotLink" @exit="GetLoginStatus"></Head>
    <top :curStep="curStep" :hasActivity="hasActivity" :stage="stage" :zhengshiModel="zhengshiModel" :yureModel="yureModel" :activitySurplusTime="activitySurplusTime"/>
    <template v-if="hasActivity">
      <div class="banner">
        <!-- 5折抢好课，红包免费领 -->
        <div class="title"></div>
        <div class="banner-content">
          <img src="https://img2.233.com/wx/union/618/2021/pc/aircraft.png" class="aircraft">
          <img src="https://img2.233.com/wx/union/618/2021/pc/red-packet.png" class="red-packet">
        </div>
        <div class="strategy"/>
      </div>
      <div class="hdgl" v-if="StrategyFlag === 1">
        <img src="https://img2.233.com/wx/union/618/2021/pc/hdgl.png">
      </div>
      <welfare :curTime="curTime" :isLogin="loginStatus.status" @openTip="openTip" @updateVisibilit="updateVisibilit"/>
      <spell :curTime="curTime" @updateVisibilit="updateVisibilit" @openCourseDialog="openCourseDialog"/>
      <hot :curTime="curTime" @updateVisibilit="updateVisibilit" @openCourseDialog="openCourseDialog"/>
      <good ref="good" :curTime="curTime" @updateVisibilit="updateVisibilit" @openCourseDialog="openCourseDialog"/>
      <rule :regList="regList" @updateVisibilit="updateVisibilit"/>
      <anav :visibilit="visibilit" @updateFixed="updateFixed"/>
      <course :courseShow="courseShow" :courseObj="courseObj" @close="courseShow = false" @openTip="openTip"/>
    </template>
    <div class="no-activity" v-else>
      <img src="https://img2.233.com/wx/union/618/2021/pc/no-activity.png" class="red-packet">
      <p>当前暂无活动</p>
    </div>
    <afooter :cnzzKey="cnzzKey" @hotLink="handlerGethotLink" />
    <div class="tips" v-show="tipShow">
      <img src="https://img2.233.com/wx/union/618/2021/pc/succeed-icon.png" v-if="tip.type === 1">
      <img src="https://img2.233.com/wx/union/618/2021/pc/fail-icon.png" v-else>
      {{tip.text}}
    </div>
  </div>
</template>

<script>
import { GetLoginStatus, Statistics, GetActivityTemplate } from "../../lib/request"
import top from "./cell/top"
import welfare from "./cell/welfare"
import spell from "./cell/spell"
import hot from "./cell/hot"
import good from "./cell/good"
import rule from "./cell/rule"
import afooter from "./cell/footer"
import anav from "./cell/nav"
import course from "./cell/course"
import Head from "./cell/Head"
export default {
  name: "Home",
  components: {
    top,
    welfare,
    spell,
    hot,
    good,
    rule,
    afooter,
    anav,
    course,
    Head
  },
  data() {
    return {
      loginStatus: {},
      cnzzKey: "",
      hasActivity: false,
      regList: [],
      StrategyFlag: 0,
      stage: 1,
      zhengshiModel: {},
      yureModel: {},
      ST: null,
      curTime: new Date().getTime(),
      tipShow: false,
      tip: {
        type: 1,
        text: ""
      },
      visibilit: {
        welfare: false,
        spell: false,
        hot: false,
        good: false,
        rule: false
      },
      courseShow: false,
      courseObj: {},
      hotLink: {}
    }
  },
  computed: {
    curStep() {
      if (new Date(this.yureModel.StartTime).getTime() <= this.curTime && new Date(this.yureModel.EndTime).getTime() >= this.curTime) {
        return 1
      } else if (new Date(this.yureModel.EndTime).getTime() < this.curTime && new Date(this.zhengshiModel.StartTime).getTime() > this.curTime) {
        return 2
      } else if (new Date(this.zhengshiModel.StartTime).getTime() <= this.curTime && new Date(this.zhengshiModel.EndTime).getTime() >= this.curTime) {
        return 3
      } else {
        return 4
      }
    },
    activitySurplusTime() {
      if (this.stage === 1) {
        return new Date(this.zhengshiModel.EndTime).getTime() - this.curTime
      } else {
        if (this.curStep === 1) {
          return new Date(this.yureModel.EndTime).getTime() - this.curTime
        } else if (this.curStep === 2) {
          return new Date(this.zhengshiModel.StartTime).getTime() - this.curTime
        } else if (this.curStep === 3) {
          return new Date(this.zhengshiModel.EndTime).getTime() - this.curTime
        } else {
          return 0
        }
      }
    }
  },
  watch: {
    activitySurplusTime(v) {
      v <= 0 && (this.hasActivity = false)
      // this.hasActivity = v > 0
    }
  },
  created() {
    this.ST = setInterval(() => {
      this.curTime = this.curTime + 1000
    }, 1000)
  },
  mounted() {
    this.GetLoginStatus()
    this.Statistics()
    this.GetActivityTemplate()
  },
  destroyed() {
    clearInterval(this.ST)
  },
  methods: {
    handlerGethotLink(item) {
      this.hotLink = item
    },
    GetLoginStatus() {
      GetLoginStatus({}, (res) => {
        const { Result } = res
        this.loginStatus = Result || {}
        document.title = Result.webName ? "双11-" + Result.webName : "11"
      })
    },
    Statistics() {
      Statistics({}, (res) => {
        const { Result } = res
        this.cnzzKey = Result.Key
        const _script1 = document.createElement("script")
        _script1.type = "text/javascript"
        _script1.src = "https://v1.cnzz.com/z_stat.php?id=" + Result.Key + "&online=1&show=line"
        document.body.appendChild(_script1)
      })
      const _script2 = document.createElement("script")
      _script2.type = "text/javascript"
      _script2.src = "https://s9.cnzz.com/z_stat.php?id=1278181871&web_id=1278181871"
      document.body.appendChild(_script2)
    },
    GetActivityTemplate() {
      GetActivityTemplate({}, (res) => {
        const { Result, ResultDescription } = res
        if (!ResultDescription) {
          const { haveActicy = 0, regList = [], stage = 1, StrategyFlag = 0, zhengshiModel = {}, yureModel = {} } = Result
          this.hasActivity = haveActicy === 1
          this.regList = regList
          regList.length > 0 && this.updateVisibilit("rule")
          this.stage = stage
          this.StrategyFlag = StrategyFlag
          this.zhengshiModel = zhengshiModel
          this.yureModel = yureModel
        }
      })
    },
    updateVisibilit(name) {
      this.visibilit[name] = true
    },
    openTip(obj) {
      this.tipShow = true
      this.tip = obj
      setTimeout(() => {
        this.tipShow = false
      }, 3000)
    },
    openCourseDialog(item = {}) {
      if (this.loginStatus.status) {
        this.courseShow = true
        this.courseObj = item
      } else {
        window.location.href = window.location.origin + "/uc/login?redirecturl=" + window.location.href
      }
    },
    updateFixed() {
      this.$refs.good && (this.$refs.good.fixed = false)
    }
  }
}
</script>

<style lang="scss" scoped>
.home{
  background: #131d5f;
  .banner{
    // height: 766px;
    background: url('https://img2.233.com/wx/union/618/2021/pc/banner.png') no-repeat top center;
    background-size: 1920px 766px;
    padding: 424px 0 48px 0;
    .title{
      font-size: 27px;
      font-weight: bold;
      color: #fff;
      line-height: 27px;
      text-shadow: 1px 2px 2px rgba(167, 23, 21, 0.75);
      text-align: center;
      // padding-top: 355px;
    }
    .banner-content{
      position: relative;
      width: 1156px;
      margin: 0 auto;
      .aircraft{
        position: relative;
        z-index: 2;
        animation: yd1 infinite 4s linear;
      }
      .red-packet{
        z-index: 1;
        position: absolute;
        top: -428px;
        right: -135px;
        animation: yd1 infinite 4s linear;
      }
      @keyframes yd1{
        0% {transform: translateY(0px);}
        50% {transform: translateY(10px);}
        100% {transform: translateY(0px);}
      }
    }
    .strategy{
      // margin: 170px auto 0;
      margin: 0 auto;
      margin-top: 20px;
      width: 480px;
      height: 90px;
      background: url('https://img2.233.com/wx/union/618/2021/pc/strategy-button.png') no-repeat top center;
      text-align: center;
    }
  }
  .hdgl{
    margin-bottom: 50px;
    text-align: center;
  }
  .no-activity{
    text-align: center;
    padding: 120px 0;
    p{
      font-size: 16px;
      color: #F8C0C2;
      font-weight: 400;
      margin-top: 20px;
    }
  }
  .tips{
    position: fixed;
    top: 50%;
    left: 50%;
    height: 50px;
    line-height: 50px;
    border-radius: 4px;
    z-index: 99;
    background: rgba(0, 0, 0, .7);
    color: #FEFEFE;
    font-size: 18px;
    padding: 0 28px;
    font-weight: 400;
    margin-top: -25px;
    margin-left: -100px;
    max-width: 300px;
    img{
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}
</style>